<div class="emma-input-color input-group">
    <div
        [ngClass]="{
            'input-group-color': true,
            nocolor: !isHexColor(value),
        }"
        [style.background-color]="isHexColor(value) ? value : ''"
    ></div>
    <div class="input-group-text"><span>#</span></div>
    <emma-input
        [autofocus]="autofocus"
        [required]="!!required"
        [readonly]="readonly"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [ngModel]="_value"
        (ngModelChange)="updateValue($event)"
        ($change)="$change.emit(value)"
        ($blur)="$blur.emit($event)"
    ></emma-input>
</div>
